import { MEMBER_STATUS } from '../constants/copy.js';

/** API (snake_case) statuses that differ from the vocabulary values. */
const STATUS_ALIASES = Object.freeze({ not_invited: MEMBER_STATUS.NOT_INVITED });

/**
 * The ONE place that derives "Expired": an invited member whose invitation expiry is in the
 * past. Any other status (including one the API already stored as `expired`) is returned as is.
 * It also maps the API's snake_case status (`not_invited`) to the vocabulary value
 * (`notInvited`), so what it returns can go straight into `StatusBadge`.
 * Contract TBD (ARP/backend): whether the backend stores Expired itself.
 *
 * @param {{ status: string, expires_at?: string|null, expiresAt?: string|null, invitation_expires_at?: string|null }} member
 * @param {Date|number} [now]
 * @returns {string} a `MEMBER_STATUS` value
 */
export const getEffectiveStatus = (member, now = Date.now()) => {
  const status = STATUS_ALIASES[member?.status] ?? member?.status;
  if (status !== MEMBER_STATUS.INVITED) return status;

  const expiresAt = member.expires_at ?? member.expiresAt ?? member.invitation_expires_at;
  if (!expiresAt) return status;

  return new Date(expiresAt).getTime() < new Date(now).getTime() ? MEMBER_STATUS.EXPIRED : status;
};
